/**
 * Lectures Coordinates Cell - Frontend
 * @description Cell component for displaying coordinates in LecturesTable
 */

import React from 'react';
import { MapPin } from 'lucide-react';
import { CellContext } from '@tanstack/react-table';
import { LecturesTableData } from '@/types/operational-ui.types';

interface LecturesCoordinatesCellProps {
  info: CellContext<LecturesTableData, string>;
}

export const LecturesCoordinatesCell: React.FC<LecturesCoordinatesCellProps> = ({ info }) => {
  const coordinatesFormatted = info.getValue();
  const row = info.row.original;

  const handleMapClick = () => {
    if (row.coordinates.latitude && row.coordinates.longitude) {
      const googleMapsUrl = `https://www.google.com/maps?q=${row.coordinates.latitude},${row.coordinates.longitude}`;
      window.open(googleMapsUrl, '_blank');
    }
  };

  return (
    <div className="text-sm text-center">
      <div
        className="flex items-center justify-center gap-1 text-gray-900 cursor-pointer hover:text-orange-500 transition-colors duration-200"
        onClick={handleMapClick}
        title="Click para abrir en Google Maps"
      >
        <MapPin className="h-3 w-3 hover:text-orange-500 transition-colors duration-200" />
        {coordinatesFormatted}
      </div>
      {/* <div className="text-xs text-gray-500">Lat: {row.latitude.toFixed(6)}</div>
      <div className="text-xs text-gray-500">Lng: {row.longitude.toFixed(6)}</div> */}
    </div>
  );
};
